
<div class="address">@if (title()) {
    <h3
        class="text-medium address__title"
    >
        {{ title() }}
    </h3>
}
    @for (line of text; track line) {
        <p
            class="address__line"
        >
            {{ line }}
        </p>
    }
</div>
